import { useMemo, useState, useRef, useEffect } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { FULL_DATE_FORMAT } from 'constants/dates';

dayjs.extend(customParseFormat);

const TIME_TO_START_CALCULATIONS = 24 * 60 * 60;

const useCallButton = (date: string) => {
  const appointmentDate = useMemo(() => dayjs(date, FULL_DATE_FORMAT), [date]);

  const [seconds, setSeconds] = useState(
    appointmentDate.diff(dayjs(), 'seconds')
  );

  const timer = useRef<number | null>(null);

  useEffect(() => {
    const timer = setInterval(() => {
      const diff = appointmentDate.diff(dayjs(), 'seconds');

      if (diff <= 0 || diff >= TIME_TO_START_CALCULATIONS) {
        clearInterval(timer);
      }

      setSeconds(diff);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [appointmentDate]);

  useEffect(() => {
    if (timer.current && seconds <= 0) {
      clearInterval(timer.current);
    }
  }, [seconds]);

  return seconds;
};

export default useCallButton;
